import React, {lazy, Suspense, useState} from 'react';
import {
    CircularProgress,
    List
} from '@material-ui/core';
import 'firebase/auth';
import Firebase from 'firebase/app';
import {ActionSection} from '../../../Common/Views/ActionSection';
import {useAuthState} from 'react-firebase-hooks/auth';
import {FeaturedLinksSection} from '../Sections/FeaturedLinks/FeaturedLinksSection';
import SocialMediaSection from '../Sections/SocialMedia/SocialMediaSection';
import useFavorites from "../../../Common/Context/Consumers/useFavorites";
import RefreshButtonView from "../Views/RefreshButtonView";
import RefreshDialog from "../Views/RefreshDialog";
import styled from "styled-components";

const JasperCardSection = lazy(()  =>  import('../Sections/JasperCard/JasperCardSection'));
const CovidTrackerSection = lazy(() => import('../Sections/Covid19/CovidTrackerSection'));
const PlannerSection = lazy(() => import('../Sections/Planner/PlannerSection'));
const QuickLinksSection = lazy(() => import('../Sections/Favorites/QuickLinks/QuickLinksSection'));
const EventsSection = lazy(() => import('../Sections/Favorites/Events/EventsSection'));
const EmployeeSection = lazy(() => import('../Sections/Favorites/Employees/EmployeeSection'));

const Container = styled(List)`
    padding-top: 0 !important;
    background-color: white;
`;

const DashboardPageController = (props: any) => {
    const {
        login,
        refresh,
        setPage,
    } = props;
    const [user] = useAuthState(Firebase.auth());
    const [open, setOpen] = useState(false);
    const favorites: any = useFavorites();

    const refreshOnClick = () => {
        setOpen(!open);
    }

    return(
        <Container>
            { !user &&
                <ActionSection
                    title={'login'}
                    prompt={'Get the most out of Glance by logging in.'}
                    action={login}
                />
            }
            { user &&
                <Suspense fallback={<CircularProgress />}>
                    <JasperCardSection
                      // refresh={refresh}
                    />
                    {/*<CovidTrackerSection />*/}
                    <PlannerSection
                        setPage={setPage}
                    />
                    {favorites &&
                        <>
                            {favorites['Quick Links'] && <QuickLinksSection />}
                            {favorites.Events && <EventsSection/>}
                            {favorites.Employees && <EmployeeSection ids={favorites.Employees}/>}
                        </>
                    }
                </Suspense>
            }
            <FeaturedLinksSection/>
            <SocialMediaSection/>
            <RefreshButtonView onClick={refreshOnClick} />
            <RefreshDialog onClick={refreshOnClick} open={open} />
        </Container>
    );
};

export default DashboardPageController;